import React from 'react'
import './adminnavbar.css'
import { BiEnvelope } from 'react-icons/bi'
import { Link } from 'react-router-dom'

const AdminNavbar = () => {
  return (
    <div className='admin_navbar_container'>
        <div className='admin_logo'>
            <h1>EWCDC ADMIN</h1>
        </div>
        <div className='admin_navlinks'>
            <Link className='linktag' to='/admin/'><li>Home</li></Link>
            <Link className='linktag' to='/admin/inbox'><li><BiEnvelope className='inbox_icon'/></li></Link>
            <Link className='linktag' to='/admin/applications'><li>Applications</li></Link>
            <Link className='linktag' to='/admin/media'><li>Media</li></Link>
        </div>
    </div>
  )
}

export default AdminNavbar